import { IGetResourcePropertiesQuery } from '~/client/graph/operations/generated/Resources.generated'

export type ResourceProperty = NonNullable<
  IGetResourcePropertiesQuery['resourceProperties']
>[number]

export enum ResourcePropertiesColumnId {
  Label = 'label',
  Name = 'name',
  Type = 'type',
  Source = 'source',
  Status = 'status',
  UpdatedAt = 'updatedAt',
}

export interface IResourcePropertyRow {
  id: string
  label: string
  name: string
  type: string
  source: string
  status: string
  createdBy: string | null
  isArchived: boolean
  updatedAt: string
}
